import { Stack } from "@altimateai/lego";
import { NoOpportunitiesImage } from "../../assets";
import { Typography } from "@altimateai/lego";

const NoInsights = ({ title, subTitle }: { title: string; subTitle: string }) => {
  return (
    <Stack direction="column" justify="center" align="center">
      <NoOpportunitiesImage />
      <Typography variant="h4">{title}</Typography>
      <Typography className="al-text-center">{subTitle}</Typography>
    </Stack>
  );
};

export default NoInsights;
